<template>
    <div class="ecb">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>展位导出</BreadcrumbItem>
                    <BreadcrumbItem>信息导出</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">信息导出</div>

                <!--                <Input-->
                <!--                        search-->
                <!--                        placeholder="请输入联系人名"-->
                <!--                        v-model="searchField"-->
                <!--                        @on-search="searchPro()"-->
                <!--                        style="width:230px;margin-top:20px;"-->
                <!--                />-->
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="exportExcel()">
                    <i class="icon iconfont icon-downLoad2"></i>
                    <span>导出展位信息</span>
                </div>
            </div>
        </div>
        <div class="layout-content" style="background: transparent;">
            <div v-if="list.length">
                <Table ref="selection" :columns="columns" :data="list" >


                </Table>
                <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
                    <Page
                            show-total
                            show-elevator
                            :page-size="pageSize"
                            :current="pageIndex"
                            :total="totalCount"
                            @on-change="changePage"
                            @on-page-size-change="changePageSize"
                    />
                </div>
            </div>
            <div class="u-empty" v-else>暂无数据</div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions, mapMutations } from "vuex";
    import axios from "axios";

    export default {
        name: "host-product",
        data() {
            return {
                company: null,
                editId: "",
                addBrandflag: false,
                showTabs: "1",
                pageSize: 10,
                pageIndex: 1,
                totalCount:0,
                list:[],
                columns: [
                    {
                        title: "公司名称",
                        key:"companyName",
                    },
                    {
                        title: "联系人",
                        key:"linkMan",
                    },
                    {
                        title: "联系人手机",
                        key:"linkMob",

                    },
                    {
                        title: "联系人邮箱",
                        key:"linkEmail",
                    },
                    {
                        title: "展区名称",
                        key:"dePjNameGroupName",

                    },
                    {
                        title: "展团名称",
                        key:"agentName",
                    },
                    {
                        title: "展位预定",
                        key:"dePjName",
                    },
                    {
                        title: "预定面积",
                        key:"area",
                    },
                    {
                        title: "注册时间",
                        key:"inTime",
                    }
                ],
                data1: [
                    {
                        companyName: 'John Brown',
                        age: 18,
                        address: 'New York No. 1 Lake Park',
                        date: '2016-10-03'
                    },
                    {
                        companyName: 'Jim Green',
                        age: 24,
                        address: 'London No. 1 Lake Park',
                        date: '2016-10-01'
                    },
                    {
                        companyName: 'Joe Black',
                        age: 30,
                        address: 'Sydney No. 1 Lake Park',
                        date: '2016-10-02'
                    },
                    {
                        companyName: 'Jon Snow',
                        age: 26,
                        address: 'Ottawa No. 2 Lake Park',
                        date: '2016-10-04'
                    }
                ],
                columns1: [
                    {
                        title: 'Name',
                        key: 'name'
                    },
                    {
                        title: 'Age',
                        key: 'age'
                    },
                    {
                        title: 'Address',
                        key: 'address'
                    }
                ],
                searchField: "" // 搜索关键字
            };
        },
        components: {

        },
        async created() {
            this.init()
        },
        computed: {
            ...mapGetters({
                exhibitionInfo: "hostSetModule/getHostExhibition",

            }),
            query() {
                return this.$route.query;
            },
            option() {
                return {
                    ExhibitionId: this.exhibitionInfo.id,
                    pageSize: this.pageSize,
                    pageIndex: this.pageIndex,
                    sorts: [{ "propertyName": "inTime", "ascending": true }],
                    Wheres: {
                        type: 0,
                        wheres: {
                            WhereGroupOperator: 0,
                            Predicates: [

                            ]
                        }
                    }
                };
            },
            // exhibitionInfo() {
            //     if (JSON.parse(localStorage.vuex)) {
            //         return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
            //     }
            // }
        },
        methods: {
            ...mapMutations({

            }),
            ...mapActions({
                getexInformationExcel: "getexInformationExcel",
                getexInformation:"getexInformation"
            }),
            async init(){
                let opt=  {
                    ExhibitionId: this.exhibitionInfo.id,
                    pageSize: this.pageSize,
                    pageIndex: this.pageIndex,
                    sorts: [{ "propertyName": "inTime", "ascending": false }],
                    Wheres: {
                        type: 0,
                        wheres: {
                            WhereGroupOperator: 0,
                            Predicates: [

                            ]
                        }
                    }
                }
                let res=await this.getexInformation(opt)

                res.items.forEach(c=>{
                    c.inTime=c.inTime.substring(0,10);
                })
                this.list=res.items
                this.pageSize = res.pageSize;
                this.pageIndex = res.pageIndex;
                this.totalCount = res.totalCount;
                console.log( this.list,'ressssssss')
            },
            changePage(e) {
                this.pageIndex = e;
                this.init();
            },
            changePageSize(e) {
                this.pageSize = e;
                this.init();
            },
            //导出信息
            async exportExcel() {
                let opt={
                    pageSize:1000000,
                    pageIndex:1,
                    exhibitionId:this.exhibitionInfo.id,
                    Wheres:{
                        type:0,
                        wheres:{
                            WhereGroupOperator:1,
                            Predicates:[{
                            },
                            ]
                        }
                    }
                }

                let data = await this.getexInformationExcel(opt);
                // if (data && data.items && data.items.length) {
                //     const exData = this.transformData(data.items);
                //     require.ensure([], () => {
                //         const {
                //             export_json_to_excel
                //         } = require("../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
                //         const tHeader = ["姓名", "公司", "职务", "手机", "地区", "注册时间"]; // 表头
                //         const filterVal = ["name", "compName", "jobTitle", "phoneNumber", "address", "time"]; // 数据
                //         const data = this.formatJson(filterVal, exData);
                //         export_json_to_excel(tHeader, data, "用户"); //列表excel  这个是导出表单的名称
                //     });
                // } else {
                //     this.$Message.warning("暂无用户数据！");
                // }
            },
        }
    };
</script>

<style scoped lang="scss">
    .eb-top-r {
        height: 100%;
        display: flex;
        align-items: flex-end;
        padding-bottom: 15px;
        &-box {
            width: 148px;
            height: 78px;
            border: 1px dashed #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: 0.5s;
            &:hover {
                border: 1px dashed #1890ff;
                transition: 0.5s;
            }
            .I1 {
                font-size: 16px;
                font-weight: bold;
                color: #1890ff;
            }
            .s3 {
                font-size: 14px;
                color: #1890ff;
                margin-left: 9px;
            }
        }
    }
</style>
